import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import { CompInfo } from '@wix/editor-elements-types/src/thunderboltExternal';
import {
  FileUploaderDefinition,
  IFileUploaderMapperProps,
} from '../FileUploader.types';
import {
  GeneralErrorTranslation,
  MediaServerErrorKeysTranslationMapping,
  TRANSLATION_FALLBACKS,
  TRANSLATION_KEYS,
  translationsNamespace,
} from '../constants';

const getTranslations = (
  translate: CompInfo<FileUploaderDefinition>['translate'],
) => {
  const errors = Object.keys(MediaServerErrorKeysTranslationMapping).reduce<{
    [key: string]: string | undefined;
  }>((acc, key) => {
    const fullTranslationKey = `upload-button.${key}`;
    acc[fullTranslationKey] = translate(
      translationsNamespace,
      fullTranslationKey,
    );
    return acc;
  }, {});

  return {
    singleFileSelectedFile:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS['FileUploader.SingleSelectedFile'],
      ) || TRANSLATION_FALLBACKS['FileUploader.SingleSelectedFile'],
    numberOfSelectedFiles:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS['FileUploader.NumberOfSelectedFiles'],
      ) || TRANSLATION_FALLBACKS['FileUploader.NumberOfSelectedFiles'],
    exceededFilesLimit:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS['FileUploader.ExceededFilesLimit'],
      ) ||
      TRANSLATION_FALLBACKS[
        'upload_button.validation_error.exceeded_files_limit'
      ],
    mobileClosePopper:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS.FileUploader_Mobile_ClosePopper,
      ) || TRANSLATION_FALLBACKS['mobile_popper.close'],
    previewFileName:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS.Upload_Button_Filename_Preview_Text_Filename,
      ) || TRANSLATION_FALLBACKS['FileUploader.NumberOfSelectedFiles'],
    multipleErrors:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS['FileUploader.MultipleErrors'],
      ) ||
      TRANSLATION_FALLBACKS[
        'upload_button.validation_error.multiple_file_errors'
      ],
    singleError:
      translate(
        translationsNamespace,
        TRANSLATION_KEYS['FileUploader.SingleError'],
      ) ||
      TRANSLATION_FALLBACKS['upload_button.validation_error.single_file_error'],
    generalError:
      translate(translationsNamespace, GeneralErrorTranslation.key) ||
      GeneralErrorTranslation.fallback,
    ...errors,
  };
};

export const props = withCompInfo<
  IFileUploaderMapperProps,
  FileUploaderDefinition,
  IFileUploaderMapperProps
>()(
  ['compId', 'isMobileView', 'translate'],
  ({ compId, isMobileView, translate }, carmiData) => {
    const translations = getTranslations(translate);
    return { ...carmiData, compId, isMobileView, translations };
  },
);

const stateRefs = withStateRefsValues([
  'enableCyclicTabbing',
  'disableCyclicTabbing',
  'setSiteScrollingBlocked',
  'scopedClassName',
]);

export default createComponentMapperModel({ props, stateRefs });
